import { defineComponent as f, toRefs as s, ref as u, computed as h, withDirectives as p, openBlock as m, createElementBlock as v, normalizeClass as g, vModelCheckbox as k } from "vue";
const y = ["value", "aria-checked"], x = /* @__PURE__ */ f({
  __name: "SfSwitch",
  props: {
    modelValue: {
      type: [String, Array, Boolean],
      default: !1
    },
    value: {
      type: String,
      default: ""
    },
    invalid: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: c }) {
    const b = e, { modelValue: r } = s(b), l = c, o = u(), t = h({
      get: () => r == null ? void 0 : r.value,
      set: (a) => l("update:modelValue", a)
    });
    return (a, d) => {
      var i;
      return p((m(), v("input", {
        ref_key: "switchRef",
        ref: o,
        "onUpdate:modelValue": d[0] || (d[0] = (n) => t.value = n),
        class: g([
          "appearance-none h-5 min-w-[36px] bg-transparent border-2 border-gray-500 rounded-full relative ease-in-out duration-300 hover:border-primary-800 hover:before:checked:bg-white checked:before:left-1/2 checked:before:ml-0 checked:before:mr-0.5 disabled:before:bg-gray-500/50 hover:before:bg-primary-800 active:border-primary-800 active:before:bg-primary-800 checked:bg-none checked:bg-primary-700 checked:border-primary-700 checked:before:bg-white hover:checked:bg-primary-800 hover:checked:border-primary-800 disabled:border-gray-500/50 checked:disabled:before:bg-white checked:disabled:bg-gray-500/50 checked:disabled:border-0 before:transition-all  before:w-3.5 before:h-3.5 before:bg-gray-500 before:absolute before:top-0 before:bottom-0 before:my-auto before:rounded-full before:left-0 before:ml-0.5 before:ease-in-out before:duration-300 cursor-pointer disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-offset",
          {
            "border-negative-700 hover:border-negative-800 active:border-negative-900 before:bg-negative-900": e.invalid
          }
        ]),
        value: e.value,
        type: "checkbox",
        role: "switch",
        "data-testid": "switch",
        "aria-checked": (i = o.value) == null ? void 0 : i.checked
      }, null, 10, y)), [
        [k, t.value]
      ]);
    };
  }
});
export {
  x as default
};
